// extracted by mini-css-extract-plugin
export default {"container":"mOZnN","buttonText":"px45p"};